export default "__VITE_ASSET__9xunwzfe__"